// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ReactNode, type ComponentProps } from 'react';
import { IssueViewSkeleton } from '@jira/issue__issue-view-skeleton/src/IssueViewSkeleton.tsx';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/ErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';

export type IssueBoundaryProps = {
	isEmbedView?: boolean;
	children: ReactNode;
} & Flow.Diff<
	JSX.LibraryManagedAttributes<typeof ErrorBoundary, ComponentProps<typeof ErrorBoundary>>,
	{
		id?: string;
	}
>;

export const IssueBoundary = ({
	children,
	isEmbedView = true,
	...props
}: IssueBoundaryProps): React.JSX.Element => (
	<ErrorBoundary id="issue" {...props}>
		<Placeholder name="issue-boundary" fallback={<IssueViewSkeleton isEmbedView={isEmbedView} />}>
			{children}
		</Placeholder>
	</ErrorBoundary>
);
